import React from "react";
import { useTranslation } from "react-i18next";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import QuteContainer from "../containers/global/global-qute/index.jsx";
import RetouchGalleryContainer from "../containers/retouch-gallery";
import Footer from "../layouts/footer";
import Header from "../layouts/header/index";
import Layout from "../layouts/index";

const RetouchGallery = () => {
    const { t } = useTranslation();
    const data = t("retouch.desc");
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title={t("retouch.title")}
                    description={t("retouch.description")}
                />
                <div className="wrapper home-default-wrapper">
                    <Header classOption="hb-border" />
                    <div className="main-content">
                        <QuteContainer data={data} />
                        <RetouchGalleryContainer />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default RetouchGallery;
